import request from '@/utils/request.js';
import Qs from 'qs';

/**
 * 
 */
export class FaceAuthControllerSvr {
    constructor() {
        this.baseurl = 'FaceAuthControllerSvr.assx/';
    }

   
    getFaceAuthCode(token,name,idNum){
        return request.post(this.baseurl + 'getFaceAuthCode', Qs.stringify({ token,name,idNum }));
    }
    getResultByKey(token,resultKey,recordsId){
        return request.post(this.baseurl + 'getResultByKey', Qs.stringify({ token,resultKey,recordsId }));
    }
    getFaceAuthSuccessByParam(token,name,idNum){
        return request.post(this.baseurl + 'getFaceAuthSuccessByParam', Qs.stringify({ token,name,idNum }));
    }

    
}